import React from 'react';
import { CircularProgress } from '@material-ui/core';

export default () => <div className="fullscreen all-center"><CircularProgress /></div>;
